/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Match_UnmatchedInputs */

const cs_demands_match_unmatched = /** @type {(inputs: Demands_Match_UnmatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez shod`)
};

const en_demands_match_unmatched = /** @type {(inputs: Demands_Match_UnmatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unmatched only`)
};

/**
* | output |
* | --- |
* | "Unmatched only" |
*
* @param {Demands_Match_UnmatchedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_match_unmatched = /** @type {((inputs?: Demands_Match_UnmatchedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Match_UnmatchedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_match_unmatched(inputs)
	return cs_demands_match_unmatched(inputs)
});